import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  NgbDropdownModule,
  NgbModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from './libs/libs.module';
import { BaseService } from './services/base.service';
import { UserService } from './services/api/user.service';
import { BankService } from './services/api/bank.service';
import { OrderService } from './services/api/order.service';
import { BalanceService } from './services/api/balance.service';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { authInterceptorProviders } from './interceptors/http.interceptor';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { ToastService } from './services/toast.service';
import { SharedModule } from './modules/shared/shared.module';
import { LoaderComponent } from './modules/shared/components/loader/loader.component';
import { OtpPipe } from './pipes/otp.pipe';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { AntDModule } from './modules/shared/antd.module';
import { TicketingModule } from './pages/ticketing/ticketing.module';
import { TicketService } from './services/api/ticket.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import en from '@angular/common/locales/en';
registerLocaleData(en);
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe);
import { provideNzI18n, en_US } from 'ng-zorro-antd/i18n';
import { WebSocketService } from './services/web-socket.service';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { AuthLayoutModule } from './layouts/auth-layout/auth-layout.module';
import { ProfileService } from './services/profile.service';
import { AuthService } from './services/auth.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { QRCodeModule } from 'angularx-qrcode';
import { PageNotFoundComponent } from './layouts/page-not-found/page-not-found.component';
import { ModeSwitchService } from './services/mode-switch.service';
import { PengaturanModule } from './pages/pengaturan/pengaturan.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { RatesTrackModule } from './pages/rates-track/rates-track.module';
import { IntegrationModule } from './pages/integration/integration.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ColorSketchModule } from 'ngx-color/sketch';
import { provideMarkdown, MarkdownModule } from 'ngx-markdown';
import { QrislyModule } from './pages/qrisly/qrisly.module';
import { GenerateQrisModule } from './pages/generate-qris/generate-qris.module';
import { DeveloperModule } from './pages/developer/developer.module';
import { KeuanganModule } from './pages/keuangan/keuangan.module';
import { AuthModule } from './pages/auth/auth.module';
import { DataOrderModule } from './pages/data-order/data-order.module';
import { BillingsModule } from './pages/billings/billings.module';
import { FeaturePagesModule } from './pages/feature-pages.module';

const ngZorroConfig: NzConfig = {
  theme: {
    primaryColor: '#F95031',
  },
};

@NgModule({ declarations: [
        AppComponent,
        LoaderComponent,
        PageNotFoundComponent,
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        LibsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDaterangepickerMd.forRoot(),
        NgbDropdownModule,
        SharedModule,
        NgbTypeaheadModule,
        AntDModule,
        TicketingModule,
        BrowserAnimationsModule,
        AuthLayoutModule,
        ScrollingModule,
        QRCodeModule,
        PengaturanModule,
        NgSelectModule,
        RatesTrackModule,
        IntegrationModule,
        DashboardModule,
        QrislyModule,
        GenerateQrisModule,
        DeveloperModule,
        KeuanganModule,
        AuthModule,
        DataOrderModule,
        BillingsModule,
        FeaturePagesModule,
        NgApexchartsModule,
        ColorSketchModule,
        MarkdownModule.forRoot({})], providers: [
        BaseService,
        UserService,
        BankService,
        OrderService,
        ToastService,
        BalanceService,
        TicketService,
        OtpPipe,
        WebSocketService,
        ProfileService,
        AuthService,
        ModeSwitchService,
        authInterceptorProviders,
        provideNzI18n(en_US),
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        { provide: NZ_CONFIG, useValue: ngZorroConfig },
        { provide: LOCALE_ID, useValue: 'en-US' },
        provideHttpClient(withInterceptorsFromDi()),
        provideMarkdown(),
    ] })
export class AppModule { }
